import { useCallback, useEffect, useState } from 'react'
import {
  RefreshControl,
  ScrollView,
  Text,
  TouchableOpacity,
  View
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// components
import Card from '../../components/shared/card/Card'
import BoardFormCategory from '../../components/board/BoardFormCategory'
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'
import ScreenStatus from '../../components/home/ScreenStatus'
import FormCard from '../../components/board/FormCard'
import ModalProgress from '../../components/shared/modal/ModalProgress'
import MyScrollView from '../../components/shared/navigator/MyScrollView'

// skeleton
import OnBoardingFormsSkeleton from '../../skeletons/OnBoardingFormsSkeleton'

// stores
import { useFormsStore } from '../../stores/onboarding'

// types
import { FromsByCategory } from '../../types/onboardingTypes'

// helpers
import { regroupFormsByCategory } from '../../helpers/onboardingHelper'
//translation
import { useTranslation } from 'react-i18next'
import CustomButton from '../../components/shared/button/Button'
import { useFocusEffect } from '@react-navigation/native'
import { useHomeStore } from '../../stores/home'
import ModalPopup from '../../components/shared/modal/ModalPopup'
import RequestForm from './RequestForm'
import { usePersonalStore } from '../../stores/personalInfo'
import { useInitializeStore } from '../../stores/initialize'



const OnBoardingFormsScreen = ({ navigation, route }: any): JSX.Element => {
  const { t } = useTranslation()
  const [formsByCategory, setFormsByCategory] = useState<
    FromsByCategory[] | null
  >(null)
  const [refreshing, setRefreshing] = useState(false)
  const [progressVisible, setProgressVisible] = useState(false)

  // params
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    refresh,
    permittedUploadExtensions
  } = params

  // store's data
  const { loading, error, formList, fetchData, markDocAsRead, progress, getRequestFormsList } =
    useFormsStore()
  const homestore = useHomeStore()
  const personalStore = usePersonalStore()
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState([])
  const initializeStore = useInitializeStore()

  // pull down to refresh the screen
  const onRefresh = useCallback(() => {
    setRefreshing(true)
    setTimeout(() => {
      navigation.replace('OnBoardingForms', { refresh: Math.random() })
      setRefreshing(false)
    }, 1000)
  }, [])


  useFocusEffect(
    useCallback(() => {
      const getData = async () => {
        try {
          fetchData(userId)
        } catch (error) {
          console.log(error)
        }
      }

      getData()
    }, [refresh])
  )

  useEffect(() => {
    if (progress > 0 && progress < 100) {
      setProgressVisible(true)
    } else {
      setProgressVisible(false)
    }
  }, [progress])

  useEffect(() => {
    if (formList?.length) setFormsByCategory(regroupFormsByCategory(formList))
  }, [formList])


  async function getData() {
    const response = await getRequestFormsList(personalStore.personalData?.entityId, initializeStore?.initializeData?.mostRecentUserOnBoardings);
    if (response) {
      setData(response?.data?.name)
    }

  }
  useEffect(() => {
    if (homestore?.homeData?.employeeFormRequestEnabled) {
      getData()
    }

  }, [personalStore.personalData?.entityId, visible])

  if (loading)
    return (
      <>
        <OnBoardingFormsSkeleton />
        {progress > 0 && progress < 100 && (
          <ModalProgress
            progress={progress}
            message={t('modaluploading')}
            visible={true}
            setVisible={setProgressVisible}
          />
        )}
      </>
    )

  if (error) return <ScreenStatus message={error} />




  return (
    formList && (
      <>
        <MyScrollView
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
        >
          <View
            style={[globalStyles.primaryBgColor, globalStyles.containerBand]}
          >
            <View style={[globalStyles.horizontalPadGap]}>

              {homestore?.homeData?.isOnboarded ?
                <HomeDetailsHeader
                  navLabel={t('Back')}
                  // navScreen='ProfileView'
                  title={t('onBoardingTitle1')}
                  description={t('onboardingdescription')}
                />
                :
                <HomeDetailsHeader
                  title={t('onBoardingTitle1')}
                  description={t('onboardingdescription')}
                />}
            </View>
            {homestore?.homeData?.employeeFormRequestEnabled &&
              <View style={{ flexDirection: "row", justifyContent: "flex-end", padding: 16 }}>
                <CustomButton text={t("Request Form")}
                  onPress={() => setVisible(true)}
                  color='light' />
              </View>}
          </View>
          <View style={[globalStyles.containerOverlap]}>


            {formsByCategory &&
              formsByCategory.map((category, catIndex) => (
                <Card key={`category_${catIndex}`}>
                  <BoardFormCategory title={t(`formCategories.${category.formCategoryDescription}`, category.formCategoryDescription)} />
                  <>
                    {category.formIds &&
                      category.formIds.map((formId, formIndex) => {
                        const { ...formProps } = formList[formId]

                        // logs
                        // console.log('...formProps', formProps)

                        return (
                          <View key={`form_${formIndex}`}>
                            <FormCard
                              {...formProps}
                              allowedExtensions={permittedUploadExtensions}
                            />
                            {category.formIds.length > formIndex + 1 && (
                              <View style={globalStyles.mb3} />
                            )}
                          </View>
                        )
                      })}
                  </>
                </Card>
              ))}
          </View>
        </MyScrollView>
        <View style={[globalStyles.mb5, globalStyles.ml3, globalStyles.mr3]}>
          <CustomButton
            text={t('home')}
            onPress={() => {
              navigation.replace('Onboarding')
            }}
          />
        </View>
        <ModalPopup visible={visible} >
          <RequestForm data={data} setVisible={setVisible} />
        </ModalPopup>
      </>
    )
  )
}

export default OnBoardingFormsScreen
